<template>
  <div>
    <footer :class="{ 'footer': true, 'bottom-space': hasBridalItemGroupMenu }">
      <div class="business-name" v-if="businessName && notCustomer">
        {{ businessName }}
      </div>
      <div
        :class="{ 'is-not-loggedin': !user }"
        v-html="copyright"
        ref="content"
      />
    </footer>
    <BridalItemGroupMenu v-if="hasBridalItemGroupMenu" />
  </div>
</template>

<script>
import initInjectedHTML from '@/utils/init-injected-html'
import BridalItemGroupMenu from './BridalItemGroupMenu.vue'

export default {
  components: {
    BridalItemGroupMenu,
  },
  data() {
    return {
      links: ''
    }
  },
  computed: {
    user() {
      return this.$store.getters['auth/check']
    },
    businessName() {
      return this.$store.state.app.businessName
    },
    copyright() {
      return this.$store.getters['theme/cleanCopyright']
    },
    notCustomer() {
      return !this.$store.getters['auth/isCustomer']
    },
    hasBridalItemGroupMenu() {
      return (
        (
          this.$store.getters['auth/isPlanner']
          || this.$store.getters['auth/isCustomer']
        ) && [
          'bridal-item.index',
          'bridal-item.show',
          'bridal-item.coordinate',
          'bridal-item.favorite',
          'simulation.index',
          'collage.index',
          'simulation-collage-history.index',
          'business.bridal-item.index',
          'business.bridal-item.show',
          'business.bridal-item.coordinate',
          'business.bridal-item.favorite',
          'business.simulation.index',
          'business.collage.index',
          'business.simulation-collage-history.index',
        ].includes(this.$route.name)
      )
    },
  },
  watch: {
    copyright: {
      handler() {
        this.$nextTick(() => {
          initInjectedHTML(this.$refs.content)
        })
      },
      immediate: true
    }
  },
  destroyed() {
    Array.from(this.links, link => {
      link.removeEventListener('click', this.handleLinkInternal, false)
    })
  }
}
</script>
